import { useQuery } from '@tanstack/react-query';
import { advisorAdminApi } from '../api/api';

// Loads the current session user's Users + Advisors records (wizard-only). Auto-fetches on mount.
export function useSelfRecord() {
  const query = useQuery({
    queryKey: ['advisorAdmin', 'self-record'],
    queryFn: () => advisorAdminApi.fetchSelfRecord(),
  });

  return {
    user: query.data?.user ?? null,
    advisor: query.data?.advisor ?? null,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    isFetching: query.isFetching,
  };
}
